"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaImageStudioURL = void 0;
var MediaImageStudioURL;
(function (MediaImageStudioURL) {
    MediaImageStudioURL["Prod"] = "https://manage.wix.com/media-image-studio";
    MediaImageStudioURL["ProdEditorX"] = "https://manage.editorx.com/media-image-studio";
    MediaImageStudioURL["Local"] = "https://local.wix.com:3010";
})(MediaImageStudioURL = exports.MediaImageStudioURL || (exports.MediaImageStudioURL = {}));
//# sourceMappingURL=urls.js.map